function snapToProductImage() {
  const url = new URL(window.location);
  const key = "variant";
  if (url.searchParams.has(key)) {
    const variant = url.searchParams.get(key);
    if (variant) {
      const image = document.getElementById(variant);
      image.scrollIntoView({ behavior: "smooth" });
    }
  }
}

function productData() {
  const rawData = document.getElementById("product-data");
  return {
    data: {
      ...JSON.parse(rawData.innerHTML),
    },
    init() {
      this.$watch("data.selected", (value) => {
        const options = Object.values(value);
        const variants = JSON.parse(JSON.stringify(this.data.variants));
        const match = variants.find((variant) =>
          variant.options.every((option, i) => option === options[i])
        );
        if (match) {
          const url = new URL(window.location);
          url.searchParams.set("variant", match.id);
          history.pushState(null, "", url.toString());

          this.data.variant_selected = match;
          this.data.disabled_cart = !match.available;

          console.log(this.data);

          snapToProductImage();
        }
      });
    },
  };
}

function marqueeComponent() {
  return {
    translateX: 0,
    speed: 0.5, // Adjust marquee speed
    isPlaying: false, // Tracks whether the animation is active
    contentWidth: 0,
    wrapperWidth: 0,
    observer: null,

    initMarquee() {
      const content = this.$refs.content;
      const wrapper = this.$refs.wrapper;

      // Duplicate content to make it seamless
      this.contentWidth = content.offsetWidth;
      this.wrapperWidth = wrapper.offsetWidth;
      content.innerHTML += content.innerHTML;

      // Set up Intersection Observer
      this.setupObserver();

      // Start the animation loop
      this.animate();
    },

    setupObserver() {
      const wrapper = this.$refs.wrapper;

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.isPlaying = entry.isIntersecting; // Play if intersecting
        },
        { threshold: 0.1 } // Trigger when at least 10% is visible
      );

      this.observer.observe(wrapper);
    },

    animate() {
      const step = () => {
        if (this.isPlaying) {
          this.translateX -= this.speed;
          if (Math.abs(this.translateX) >= this.contentWidth) {
            this.translateX = 0; // Reset position
          }
        }
        requestAnimationFrame(step);
      };
      step();
    },
  };
}

function isProductPage() {
  // Check for a marker
  return (
    document.querySelector('[data-page="product"]') !== null ||
    window.location.pathname.includes("/products/")
  );
}
function isCollectionPage() {
  // Check for a marker
  return (
    document.querySelector('[data-page="collection"]') !== null ||
    window.location.pathname.includes("/collections/")
  );
}

function initCollection() {
  if (isCollectionPage()) {
    document
      .querySelector("#product-filter")
      .addEventListener("change", function () {
        const formData = new FormData(this);
        const params = new URLSearchParams(formData);
        const newURL = `${window.location.pathname}?${params.toString()}`;
        SWUP.navigate(newURL);
        SWUP.hooks.on("page:view", (e) => {
          console.log(e);
          const comp = document.getElementById("product-grid");
          if (comp) {
            console.log("PAGE:VIEW =>", e);
            comp.scrollIntoView({ behavior: "instant" });
          }
        });
      });
  }
}

/**
 * Initialize product data at dom loaded or swup
 */
function initProductRecomendations() {
  if (isProductPage()) {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector(
            ".product-recommendations"
          );

          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    const productRecommendationsSection = document.querySelector(
      ".product-recommendations"
    );
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 200px 0px",
    });

    observer.observe(productRecommendationsSection);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const swup = new Swup({
    animationScope: "containers",
    native: true,
    containers: [
      "#main-content",
      // "#header-info"
    ],
    plugins: [
      new SwupProgressPlugin(),
      new SwupPreloadPlugin(),
      new SwupA11yPlugin(),
      new SwupHeadPlugin(),
    ],
  });

  window.SWUP = swup;

  document.querySelectorAll("a").forEach((link) => {
    const href = link.getAttribute("href");
    if (href && href.startsWith("http")) {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "nofollow");
    }
  });

  initProductRecomendations();
  initCollection();
  snapToProductImage();

  document.addEventListener("swup:page:view", ({ detail: { visit } }) => {
    initProductRecomendations();
    initCollection();

    if (visit.to.url.startsWith("/products/")) {
      snapToProductImage();
    }
  });
});
